import axios from 'axios';

// username
export async function fetchUsernameAPI() {
	let username = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}users/username`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		username = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return username;
}

export async function fetchUsersName() {
	let usersNamelist = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}users/names/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		usersNamelist = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return usersNamelist;
}

/*from search Customer to users added as of aug 5 2022 2:57 pm*/
export async function fetchUsers(payload) {
	let userslist = [];

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}users/search`,
			data: payload,
			headers: {
				'content-type': 'application/json',
			},
		});
        console.log("🚀 ~ file: fetch_customers.jsx ~ line 15 ~ fetchCustomers ~ response", response)

		const { data } = response;
		userslist = data;
	} catch (error) {
		throw error;
		// Message.error();
	}

	return userslist;
}



// search users api
export async function searchUsersAPI(payload) {
	const UserName = payload.user_name === undefined ? '' : payload.user_name;
	const Role = payload.role_name === undefined ? '' : payload.role_name;
	const LastName = payload.last_name === undefined ? '' : payload.last_name;
	const FirstName = payload.first_name === undefined? '' : payload.first_name;
	const Status = payload.status === undefined? '' : payload.status;
	let userslist = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}users/search/?user_name=${UserName}&role_name=${Role}&last_name=${LastName}&first_name=${FirstName}&status=${Status}`,
			data: payload,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		userslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return userslist;
}

//create agents api
export async function createUsersAPI(Data) {
	let userData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}users/create/`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		userData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return userData;
}

//update users api
export async function updateUsersAPI(Data) {
	let userData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}users/update/`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		userData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return userData;
}